import React, { useState } from 'react';
import { BubbleButton, BubbleFormGroup, BubbleInput, BubbleTextArea } from '@go-client/components/BubbleUI';

import { createBugReport } from '@go-client/lib/api/bugReport';
import { BugReportParamsCreate } from '@go-shared/types/bugReport';
import { useUserInfo } from '@go-client/context/UserInfoContext';

type BugReportForm = {
  userId: string;
  bugDescription: string;
  shortDescription: string;
  _dirty: boolean;
  mode: string;
}

export default function bugReportForm() {
  const { user } = useUserInfo();

  const [bugReportForm, setBugReportForm] = useState<BugReportForm>({
    _dirty: false,
    bugDescription: '',
    mode: '',
    shortDescription: '',
    userId: '',
  });



  async function handleSubmitBugReportForm() {
    if (!bugReportForm) return;

    const bugForm = {
      bugDescription: bugReportForm.bugDescription,
      shortDescription: bugReportForm.shortDescription,
      
    };

    
    const newBug: BugReportParamsCreate = {
      userId: user._id,
      bugDescription: bugForm.bugDescription,
      shortDescription: bugForm.shortDescription,
        
    };

    await createBugReport(newBug);
   
    
  }
  
    function changeBugReportForm<T extends keyof BugReportForm>(key: T, val: BugReportForm[T]) {
      if (!bugReportForm || ['_dirty'].includes(key)) return;

    setBugReportForm({
      ...bugReportForm,
      [key]: val,
      _dirty: true,
    });
    }

  return (
    <>
      <BubbleFormGroup label="Title" >
        <BubbleInput
          type="text"
          block
          value={bugReportForm?.shortDescription}
          onValue={val => changeBugReportForm('shortDescription', val)}
        />
        <span className="text-xs italic"> * Use less than 5 words.</span>
      </BubbleFormGroup>
      <BubbleFormGroup label="Issue Description">
        <BubbleTextArea
          block
          value={bugReportForm?.bugDescription}
          onValue={(val: string) => changeBugReportForm('bugDescription', val)}
        />
      </BubbleFormGroup>
      <BubbleButton
          className="text-left"
          icon="file-export"
          variant="navy"
          onClick={() => handleSubmitBugReportForm()}
        >
          Send Report
        </BubbleButton>
    </>
  );
}
